import { AddGames } from "./Steps/AddGames";
import { ConfigureProject } from "./Steps";
import { GameSettings } from "./Steps/GameSettings";
import { useStep } from "../../../../contexts/step/StepContext";
import { CustomizeVisuals } from "./Steps/CustomizeVisuals";
import { AdvancedSettings } from "./Steps/AdvancedSettings";
import { GameResults } from "./Steps/GameResults";

import styles from "./ProjectSettings.module.scss";

export const ProjectSettings = () => {
  const { currentStep } = useStep();

  const stepToRender = [
    <ConfigureProject key={1} />,
    <AddGames key={2} />,
    <GameSettings key={3} />,
    <AdvancedSettings key={4} />,
    <CustomizeVisuals key={5} />,
    <GameResults key={6} />,
  ][currentStep - 1];

  return <div className={styles.projectSettings}>{stepToRender}</div>;
};
